import { useEffect } from 'react'
import ScrollReveal from 'scrollreveal'

import css3 from '../../images/skills/css3.jpg'
import javascript from '../../images/skills/javascript.png'
import reactjs from '../../images/skills/reactjs.png'
import tailwindcss from '../../images/skills/tailwindcss.png'

const Skills = () => {
  useEffect(() => {
    const scroll = ScrollReveal({
      origin: 'top',
      distance: '5rem',
      duration: 2000,
      reset: true
    })

    scroll.reveal('.skill_img', { delay: 600, interval: 500 })
  }, [])
  return (
    <section id='skills'>
      <div className='skills container'>
        <div className='skill-top'>
          <h1 className='section-title'>
            Sk<span>i</span>lls
          </h1>
          <p className='title_info'>
            This are the following skill set am compentent in.
          </p>
        </div>
        <div className='skill_set'>
          <div className='skill'>
            <div className='skill_img'>
              <img src={javascript} alt='javascript' />
            </div>
            <p className='title_info'>JavaScript</p>
          </div>

          <div className='skill'>
            <div className='skill_img'>
              <img src={reactjs} alt='reactjs' />
            </div>
            <p className='title_info'>ReactJs</p>
          </div>

          <div className='skill'>
            <div className='skill_img'>
              <img src={tailwindcss} alt='tailwindcss' />
            </div>
            <p className='title_info'>Tailwindcss</p>
          </div>

          <div className='skill'>
            <div className='skill_img'>
              <img src={css3} alt='css3' />
            </div>
            <p className='title_info'>CSS3</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Skills
